/*
  File: italiansecret-review-widget.js

  Purpose:
  Inline review block logic:
  - Fetch TSV reviews.
  - Render a horizontal slider with multiple reviews.
  - Support arrow navigation and swipe.
*/
// Added by Italian Secret on 2026-01-16

(function () {
  const containers = Array.from(document.querySelectorAll('[data-is-tp-inline]'));
  if (!containers.length) return;

  const fetchCache = new Map();

  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  function sanitize(str) {
    return String(str || '')
      .replace(/\r?\n+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function starsString(rating) {
    return '★★★★★'.slice(0, Math.max(0, Math.min(5, rating)));
  }

  function parseTSV(text) {
    const lines = text.split('\n').filter(l => l.trim());
    if (lines.length <= 1) return [];

    return lines.slice(1).map(line => {
      const c = line.split('\t');
      return {
        reviewUrl: sanitize(c[1]),
        authorName: sanitize(c[2]),
        rating: Number(c[3]) || 0,
        headline: sanitize(c[4]),
        reviewText: sanitize(c[5])
      };
    }).filter(r => r.reviewText && r.reviewUrl);
  }

  function getReviews(tsvUrl) {
    if (!tsvUrl) return Promise.resolve([]);
    if (fetchCache.has(tsvUrl)) return fetchCache.get(tsvUrl);

    const promise = fetch(tsvUrl, { cache: 'no-store' })
      .then(res => res.text())
      .then(parseTSV)
      .catch(() => []);

    fetchCache.set(tsvUrl, promise);
    return promise;
  }

  function buildCard(review, options) {
    const card = document.createElement('a');
    card.className = 'is-tp-inline__card';
    card.href = review.reviewUrl;
    card.target = '_blank';
    card.rel = 'noopener';

    card.innerHTML =
      '<div class="is-tp-inline__top">' +
        '<span class="is-tp-inline__stars" aria-hidden="true"></span>' +
        '<span class="is-tp-inline__author"></span>' +
      '</div>' +
      '<div class="is-tp-inline__headline"></div>' +
      '<div class="is-tp-inline__body"></div>' +
      '<div class="is-tp-inline__meta">' +
        '<span class="is-tp-inline__cta">Read more</span>' +
      '</div>';

    const starsEl = card.querySelector('.is-tp-inline__stars');
    if (options.showStars) {
      starsEl.textContent = starsString(review.rating);
    } else {
      starsEl.remove();
    }

    card.querySelector('.is-tp-inline__author').textContent = review.authorName;
    card.querySelector('.is-tp-inline__headline').textContent = review.headline;
    card.querySelector('.is-tp-inline__body').textContent = review.reviewText;

    if (!options.showReviewLink) {
      card.removeAttribute('href');
      card.removeAttribute('target');
      card.removeAttribute('rel');
      card.classList.add('is-tp-inline__card--nolink');
      const cta = card.querySelector('.is-tp-inline__cta');
      if (cta) cta.remove();
    }

    return card;
  }

  function hideContainer(container) {
    container.style.display = 'none';
  }

  function updateNavState(track, prevBtn, nextBtn) {
    if (!track || !prevBtn || !nextBtn) return;
    const maxScroll = track.scrollWidth - track.clientWidth;
    prevBtn.disabled = track.scrollLeft <= 4;
    nextBtn.disabled = track.scrollLeft >= maxScroll - 4;
  }

  function getStepSize(track) {
    if (!track) return 0;
    const card = track.querySelector('.is-tp-inline__card');
    if (!card) return track.clientWidth;
    const styles = window.getComputedStyle(track);
    const gap = Number.parseFloat(styles.columnGap || styles.gap || 0) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function scrollByCard(track, direction) {
    if (!track) return;
    const step = getStepSize(track);
    if (!step) return;
    const current = track.scrollLeft;
    const targetIndex = Math.round(current / step) + direction;
    const nextLeft = Math.max(0, targetIndex * step);
    track.scrollTo({ left: nextLeft, behavior: 'smooth' });
  }

  async function initContainer(container) {
    const tsvUrl = container.getAttribute('data-tsv-url');
    const showStars = container.getAttribute('data-show-stars') !== 'false';
    const showReviewLink = container.getAttribute('data-show-review-link') !== 'false';
    const reviews = shuffle(await getReviews(tsvUrl));

    if (!reviews.length) {
      hideContainer(container);
      return;
    }

    const viewport = container.querySelector('[data-is-tp-inline-viewport]');
    const track = container.querySelector('[data-is-tp-inline-track]');
    const prevBtn = container.querySelector('[data-is-tp-inline-prev]');
    const nextBtn = container.querySelector('[data-is-tp-inline-next]');

    if (!viewport || !track) return;

    track.innerHTML = '';
    reviews.forEach(review => {
      track.appendChild(buildCard(review, { showStars, showReviewLink }));
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => scrollByCard(track, -1));
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => scrollByCard(track, 1));
    }

    updateNavState(track, prevBtn, nextBtn);
    track.addEventListener('scroll', () => updateNavState(track, prevBtn, nextBtn));
  }

  containers.forEach(initContainer);
})();
